"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var styleOverrides = {
    tooltip: function(param) {
        var theme = param.theme;
        return {
            backgroundColor: theme.palette.grey[200],
            color: theme.palette.text.primary,
            boxShadow: 'none',
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 'normal',
            maxWidth: 300,
            textAlign: 'center',
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius
        };
    },
    arrow: function(param) {
        var theme = param.theme;
        return {
            color: theme.palette.grey[200],
            '&:before': {
                boxShadow: 'none'
            }
        };
    }
};
var defaultProps = {
    arrow: true
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiTooltip.js.map
